module.exports = __webpack_public_path__ + "img/Value1.269987c3.png";